import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/vacation-planes',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: '/settings/vacation-planes/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/settings/vacation-planes/${id}`,
      method: 'get'
  })
}
export function getStaffInfo(id) {
  return request({
      url: `/settings/vacation-management/staff/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/vacation-planes',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/vacation-planes/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/settings/vacation-planes/${id}`,
      method: 'delete',
  })
}
export function getStaffs(id) {
  return request({
      url: `/settings/vacation-plane-staffs/${id}`,
      method: 'get'
  })
}
export function saveStaffList(data) {
  return request({
      url: `/settings/vacation-plane-staffs/${data.id}/update`,
      method: 'post',
      data
  })
}
